import type { CollabClient, CollabRoom } from '@flobi/collab-client';

/**
 * Leaving a file: whatever the server has not acknowledged gets a moment to go out before the
 * rooms close. What is still waiting is on this device (IndexedDB) and goes out the next time
 * the file opens, so this is a courtesy to the people still in it, not the only copy.
 */
export function closeWhenSent(client: CollabClient, rooms: readonly CollabRoom[], ms: number): void {
  const settled = () => rooms.every((room) => room.unsynced === 0 || room.status === 'refused' || room.status === 'closed');
  if (settled()) {
    client.destroy();
    return;
  }
  const offs: (() => void)[] = [];
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    clearTimeout(timer);
    for (const off of offs) off();
    client.destroy();
  };
  const timer = setTimeout(finish, ms);
  for (const room of rooms) {
    offs.push(room.on('unsynced', () => settled() && finish()));
    offs.push(room.on('status', () => settled() && finish()));
  }
}
